import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetEdc_sharing_groupIdSettlement = z.any()
export type TagsGetEdc_sharing_groupIdSettlement = z.infer<typeof tagsGetEdc_sharing_groupIdSettlement>

export const paramsGetEdc_sharing_groupIdSettlement = z.object({ "groupId": z.string() })
export type ParamsGetEdc_sharing_groupIdSettlement = z.infer<typeof paramsGetEdc_sharing_groupIdSettlement>

export const querystringGetEdc_sharing_groupIdSettlement = z.object({ "from": z.string().date(), "to": z.string().date() })
export type QuerystringGetEdc_sharing_groupIdSettlement = z.infer<typeof querystringGetEdc_sharing_groupIdSettlement>

export const responseGetEdc_sharing_groupIdSettlement = z.object({ "payload": z.object({ "from": z.string(), "to": z.string(), "expectedIntervals": z.number(), "validIntervals": z.number(), "invalidIntervals": z.number(), "sourceHash": z.string(), "generatedKwh": z.number(), "exportedKwh": z.number(), "sharedKwh": z.number(), "producer": z.union([z.record(z.any()).and(z.intersection(z.object({ "ean": z.string(), "role": z.string(), "name": z.string() }), z.object({ "key": z.string() }))), z.null()]), "recipients": z.array(z.record(z.any()).and(z.intersection(z.object({ "ean": z.string(), "role": z.string(), "name": z.string() }), z.object({ "key": z.string(), "sharedKwh": z.number() })))), "readyForDraft": z.boolean(), "warnings": z.array(z.string()) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetEdc_sharing_groupIdSettlement = z.infer<typeof responseGetEdc_sharing_groupIdSettlement>

interface IGetEdc_sharing_groupIdSettlement extends BaseMethodType {
  tags: TagsGetEdc_sharing_groupIdSettlement,
  params: ParamsGetEdc_sharing_groupIdSettlement,
  querystring: QuerystringGetEdc_sharing_groupIdSettlement,
  response: ResponseGetEdc_sharing_groupIdSettlement
}
export const URL = '/edc-sharing/:groupId/settlement'
export const validation = {
  get: {
    tags: tagsGetEdc_sharing_groupIdSettlement,
    params: paramsGetEdc_sharing_groupIdSettlement,
    querystring: querystringGetEdc_sharing_groupIdSettlement,
    response: responseGetEdc_sharing_groupIdSettlement
  }
}
export interface Edc_sharing_groupIdSettlement extends BaseRouteType {
  get: IGetEdc_sharing_groupIdSettlement
}